module.exports = __webpack_public_path__ + "img/uploadxlx.d1325753.svg";